<template>
    <div class="my-finance">
        <el-row class="infoLink">
            <router-link to="/my/finance/deposit">{{
                $t("myPage.Deposit")
            }}</router-link>
            <router-link to="/my/finance/withdraw">{{
                $t("myPage.drawing")
            }}</router-link>
            <!-- <router-link to="/my/finance/transfer">户内转账</router-link> -->
        </el-row>
        <router-view></router-view>
    </div>
</template>
<script>
export default {};
</script>